/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import Content from "../../../Components/Dashboard/Content/Content";
import BasicDataTable from "../../../Components/ExtraComponents/Datatable/BasicDataTable";
import { GET_COMPANY_INFOS } from "../../../ReduxStore/Slice/Admin/AdminSlice";
import { DisclaimerMessage } from "../../../ReduxStore/Slice/Admin/SystemSlice";
import { Pencil } from "lucide-react";
import ToastButton from "../../../Components/ExtraComponents/Alert_Toast";
import toast from "react-hot-toast";
import $ from "jquery";
import UpdateCompanyInfo from "./UpdateCompanyInfo";
import UpdateImages from "./UpdateImages";
import UpdateSmptDetails from "./UpdateSmptDetails";
import { useDispatch } from "react-redux";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import axios from "axios";
import * as Config from "../../../Utils/Config";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";

const System = () => {
  const dispatch = useDispatch();
  const [diss, setDiss] = useState("");
  const [inputs, setInputs] = useState([]);
  const [getDissStatus, setDissStatus] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [showImgModal, setshowImgModal] = useState(false);
  const [ShowEmailModal, setShowEmailModal] = useState(false);
  const [PanelDetailsModal, setPanelDetailsModal] = useState(false);
  const [emailLogoImg, setEmailLogoImg] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [getCompanyName, setCompanyName] = useState({
    loading: true,
    data: [],
  });
  const [pdfFileExist, setpdfFileExist] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);

  useEffect(() => {
    CompanyName();
  }, []);

  const CompanyName = async () => {
    const response = await dispatch(GET_COMPANY_INFOS()).unwrap();
    if (response.status) {
      const [companyInfo] = response.data;
      setPreviewUrl(companyInfo.Emaillogo);
      setDiss(companyInfo.disclaimer);
      setDissStatus(companyInfo.disclaimer_status);
      setInputs(companyInfo.dissArr);
      setCompanyName({ loading: false, data: response.data });
      setpdfFileExist(response.data[0].welcome_message_pdf);

      let favicon = $("link[rel='icon']").length
        ? $("link[rel='icon']")
        : $("<link rel='icon' type='image/x-icon' />");
      favicon.attr("href", companyInfo.favicon);
      $("head").append(favicon);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEmailLogoImg(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const UpdateEmailLogo = async () => {
    if (!emailLogoImg) return alert("Please select an image first!");
    const formData = new FormData();
    formData.append("image", emailLogoImg);

    try {
      const res = await axios.post(
        Config.base_url + "update/email/logo",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      res.status
        ? toast.success("Email Logo updated successfully!")
        : toast.error("Error updating Email Logo!");
    } catch (error) {
      toast.error("Image upload failed");
    }
  };

  const handleSubmit = async () => {
    const data1 = inputs.map((input, index) => ({
      id: index + 1,
      value: input.value,
    }));
    const payload = {
      id: "6501756b2a8e6d952493b7f4",
      disclaimer: diss,
      dataArr: data1,
    };

    const response = await dispatch(DisclaimerMessage(payload)).unwrap();
    response.status
      ? toast.success("Disclaimer added successfully...")
      : toast.error("Disclaimer add error");
    setRefresh(!refresh);
  };

  const updateDiscStatus = async (e) => {
    const payload = {
      id: "6501756b2a8e6d952493b7f4",
      disclaimer_status: e.target.checked ? "1" : "0",
    };
    const response = await dispatch(DisclaimerMessage(payload)).unwrap();
    response.status
      ? window.location.reload()
      : toast.error("Disclaimer status update error");
  };

  const handlePdfUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      setPdfFile(file);
      const fileURL = URL.createObjectURL(file);
      setpdfFileExist(fileURL); // This will be used for preview
    } else {
      alert("Please select a valid PDF file.");
    }
  };

  const PageStatus = localStorage.getItem("pageStatus") || 1;
  const setPageStatus = (k) => localStorage.setItem("pageStatus", k);

  const renderImage = (src, alt = "") => (
    <img
      src={src}
      alt={alt}
      className="logo-abbr w-25"
      width="100"
      height="100"
    />
  );

  const handleSubmitWelcomeMessage = async () => {
    if (!pdfFile) {
      alert("Please select a PDF file first!");
      return;
    }
    const formData = new FormData();
    formData.append("pdf", pdfFile);

    try {
      const res = await axios.post(
        Config.base_url + "update/welcomeMessage/pdf",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (res.data.status) {
        toast.success("Welcome message updated successfully!");
        // window.location.reload();
      } else {
        toast.error("Error updating Welcome message!");
      }
    } catch (error) {
      toast.error("Error uploading PDF file!");
    }
  };
  return (
    <Content Page_title="System" button_status={false}>
      <Tabs
        defaultActiveKey={PageStatus}
        id="system-tabs"
        className="mb-3"
        fill
        onSelect={setPageStatus}
      >
        <Tab eventKey="1" title="Company Information">
          <h2>Company Information</h2>
          <BasicDataTable
            tableData={getCompanyName.data}
            TableColumns={[
              {
                dataField: "index",
                text: "Company ID",
                formatter: (_, __, i) => i + 1,
              },
              { dataField: "panel_name", text: "Company Name" },
              { dataField: "panel_short_name", text: "Company Short Name" },
              { dataField: "prefix", text: "Version" },
              {
                dataField: "Action",
                text: "Action",
                formatter: () => (
                  <Pencil
                    size={20}
                    color="#198754"
                    strokeWidth={2}
                    className="mx-1"
                    onClick={() => setPanelDetailsModal(true)}
                  />
                ),
              },
            ]}
            dropdown={false}
          />
        </Tab>

        <Tab eventKey="2" title="Email Information">
          <h2>Email Information</h2>
          <BasicDataTable
            tableData={getCompanyName.data}
            TableColumns={[
              {
                dataField: "id",
                text: "Email ID",
                formatter: (_, __, i) => i + 1,
              },
              { dataField: "email", text: "Email" },
              { dataField: "cc_mail", text: "CC" },
              { dataField: "bcc_mail", text: "BCC" },
              { dataField: "smtp_password", text: "Password" },
              { dataField: "smtphost", text: "SMTP Host" },
              { dataField: "smtpport", text: "SMTP Port" },
              {
                dataField: "Action",
                text: "Action",
                formatter: () => (
                  <Pencil
                    size={20}
                    color="#198754"
                    strokeWidth={2}
                    className="mx-1"
                    onClick={() => setShowEmailModal(true)}
                  />
                ),
              },
            ]}
            dropdown={false}
          />
        </Tab>

        <Tab eventKey="3" title="Background Images">
          <h2>Background Images</h2>
          <BasicDataTable
            tableData={getCompanyName.data}
            TableColumns={[
              { dataField: "id", text: "ID", formatter: (_, __, i) => i + 1 },
              { dataField: "favicon", text: "Favicon", formatter: renderImage },
              { dataField: "logo", text: "Logo", formatter: renderImage },
              {
                dataField: "loginimage",
                text: "Login Image",
                formatter: renderImage,
              },
              {
                dataField: "watermark",
                text: "Water Mark",
                formatter: renderImage,
              },
              {
                dataField: "Action",
                text: "Action",
                formatter: () => (
                  <Pencil
                    size={20}
                    color="#198754"
                    strokeWidth={2}
                    className="mx-1"
                    onClick={() => setshowImgModal(true)}
                  />
                ),
              },
            ]}
            dropdown={false}
          />

          <hr />

          <h2>Email Logo</h2>
          <input
            type="file"
            className="form-control mb-2"
            onChange={handleImageChange}
          />
          {/* {previewUrl && renderImage(previewUrl)}  */}
          {previewUrl && (
            <img
              src={
                previewUrl.startsWith("http") || previewUrl.startsWith("data:")
                  ? previewUrl
                  : `${
                      window.location.origin === "http://localhost:3000"
                        ? "https://newpenal.deepmindinfotech.com/images/"
                        : `${window.location.origin}/images/`
                    }${previewUrl}`
              }
              alt="Email Logo"
              className="logo-abbr w-25"
              width="100"
              height="100"
            />
          )}

          <button className="btn btn-primary mt-2" onClick={UpdateEmailLogo}>
            Submit
          </button>
        </Tab>

        <Tab eventKey="4" title="Disclaimer Message">
          <div className="Disclamer">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2>Disclaimer Message</h2>
              <div className="toogle-new">
                <input
                  type="checkbox"
                  id="switch"
                  checked={Number(getDissStatus) === 1}
                  onChange={updateDiscStatus}
                />
                <label htmlFor="switch">Toggle</label>
              </div>
            </div>

            <ReactQuill
              value={diss}
              onChange={setDiss}
              theme="snow"
              className="mb-3"
              placeholder="Enter your disclaimer message"
              modules={{
                toolbar: [
                  [{ header: [1, 2, false] }],
                  ["bold", "italic", "underline"],
                  ["link", "image"],
                  [{ list: "ordered" }, { list: "bullet" }],
                  ["clean"],
                ],
              }}
            />

            <button className="btn btn-primary" onClick={handleSubmit}>
              Submit
            </button>
            <hr />

            <h2 className="mt-4">Disclaimer Pdf</h2>
            <div className="mb-3">
              <label htmlFor="pdfUpload" className="form-label">
                Attach PDF File:
              </label>
              <input
                type="file"
                className="form-control"
                id="pdfUpload"
                accept="application/pdf"
                onChange={(e) => handlePdfUpload(e)}
              />
            </div>

            {pdfFileExist && (
              <div className="mt-3 text-success">
                <FontAwesomeIcon icon={faFilePdf} style={{ color: "red" }} />
                Selected File: <strong>{pdfFile?.name}</strong>
              </div>
            )}

            {pdfFileExist &&
              pdfFileExist.startsWith("https://") &&
              pdfFileExist.toLowerCase().endsWith(".pdf") && (
                <div className="mt-4">
                  <iframe
                    src={pdfFileExist}
                    title="PDF Preview"
                    width="100%"
                    height="500px"
                    style={{ border: "1px solid #ccc" }}
                  ></iframe>
                </div>
              )}

            <button
              className="btn btn-primary"
              onClick={handleSubmitWelcomeMessage}
            >
              Submit
            </button>
          </div>
        </Tab>
        
        <Tab eventKey="5" title="Email Preview">
          <div className="Disclamer">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2>Email Preview</h2>
              {/* CREATE A INPUT TO EMAIL AND SUBMIT BTN TO HIT A API TO SEND EMAIL AND RESPONSE RETURN HTML AND SHOW THERE HTML NSIDE
               */}

              <input
                type="email"  
                className="form-control w-50"
                placeholder="Enter email address"
                onChange={(e) => setInputs(e.target.value)}
              />
              <button
                className="btn btn-primary"
                onClick={() => {
                  // Call API to send email and get HTML response
                  axios
                    .post(Config.base_url + "check/Disclaimer", {
                      Email: inputs,
                    })
                    .then((response) => {
                      console.log(response.data);
                      if (response.data) {
                        toast.success("Email sent successfully!");

                        // Assuming response.data contains the HTML content
                        const emailContent = response.data;
                        const newWindow = window.open("", "_blank");
                        newWindow.document.write(` 
                          <html>
                            <head>
                              <title>Email Preview</title>
                              <style>
                                body { font-family: Arial, sans-serif; }
                                .email-content { padding: 20px; }
                              </style>
                            </head>
                            <body>
                              <div class="email-content">
                                ${emailContent}
                              </div>
                            </body>
                          </html>
                        `);
                        newWindow.document.close();




                      } else {
                        toast.error("Error sending email!");
                      }
                    })
                    .catch((error) => {
                      toast.error("Error sending email!");
                    });
                }}
              >
                Send Test Email
              </button> 
                

          

          </div>

          </div>
        </Tab>
      </Tabs>

      <UpdateCompanyInfo
        data={getCompanyName.data}
        showModal={PanelDetailsModal}
        setshowModal={() => setPanelDetailsModal(false)}
      />
      <UpdateSmptDetails
        data={getCompanyName.data}
        showModal={ShowEmailModal}
        setshowModal={() => setShowEmailModal(false)}
      />
      <UpdateImages
        data={getCompanyName.data}
        showModal={showImgModal}
        setshowModal={() => setshowImgModal(false)}
      />
      <ToastButton />
    </Content>
  );
};

export default System;
